import { useIxmUserauthV1ProgramQueryServiceProgramGet } from '../generated/hooks';
import { useProgramMetaAccessSelector } from './program-auth-access-selector';

export function useGetProgram(
  request: Parameters<typeof useIxmUserauthV1ProgramQueryServiceProgramGet>[0],
  options?: Parameters<typeof useIxmUserauthV1ProgramQueryServiceProgramGet>[1],
  withAccess?: Parameters<typeof useIxmUserauthV1ProgramQueryServiceProgramGet>[2],
) {
  const programMetaAccess = useProgramMetaAccessSelector(request?.programId);

  return useIxmUserauthV1ProgramQueryServiceProgramGet(request, options, withAccess ?? programMetaAccess);
}
